






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import EchartOption from '@root/common/const/e-chart-options';

@Component({
  components: {}
})
export default class ParktimeDistribution extends Vue {
  commaNumber(value: any) {
    if (value === null || value === undefined) {
      return '0';
    }
    if (isNaN(value)) {
      return value;
    } else {
      return (value + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  options: EchartOption = new EchartOption();
  isData: boolean = true;

  @Prop({ default: () => [] })
  data!: any[];

  @Watch('data')
  onDataChange(val: any) {
    this.$nextTick(() => {
      this.refreshChart();
    });
  }

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      show: true,
      trigger: 'item'
      // formatter: '{a} <br/>{b} : {c}%',
    };
  }

  get grid() {
    return {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false
    };
  }

  get xAxis() {
    return {
      show: false
    };
  }

  get yAxis() {
    return [
      {
        type: 'value',
        axisLabel: {
          show: true
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      }
    ];
  }

  get series() {
    return [
      {
        name: 'TOP车场',
        type: 'pie',
        radius: ['65%', '85%'],
        data: this.data.map(i => {
          return { name: i.describe, value: i.value };
        }),
        itemStyle: {
          borderWidth: 5,
          borderColor: '#fff'
        },
        label: {
          position: 'center',
          formatter: `{title|TOP车场}`,
          rich: {
            title: {
              color: '#999',
              fontSize: 14,
              padding: [0, 0, 0, 0]
            }
          }
        }
      }
    ];
  }

  get colors() {
    return [
      '#3aa1ff',
      '#4ecb73',
      '#f2637b',
      '#975fe5',
      '#fbd437',
      '#c8a62c',
      '#a30014',
      '#b8741a',
      '#4b7902',
      '#81d3f8'
    ];
  }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setColor(this.colors);
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    this.options = options;
  }

  init() {}

  mounted() {
    this.refreshChart();
  }
}
